export { default } from 'ember-click-outside/modifier';
